import { z } from "zod/v4";

import * as y from "../schemas";

/**
 * Schema for FloorSpaceCatalog records from the API.
 * Only includes fields needed for the firmware view mode.
 */
export const schema = z.looseObject({
    floorSpaceCatalogID: y.id(),
    firmwareVersion: z.string().nullish(),
});

/**
 * FloorSpaceCatalog record with firmware version data.
 */
export type FloorSpaceCatalog = z.infer<typeof schema>;
